module.exports = __webpack_public_path__ + "static/media/tiburones.9752a813.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/tiburones.png
// module id = 134
// module chunks = 0